import { useTranslations } from 'next-intl'
import React from 'react'
import LogoutIcon from '@/components/ui/icons/logout'
import { useLogout } from '@/utils/auth/useLogout'

const LogoutButton = ({ className }: { className?: string }) => {
  const t = useTranslations()
  const { logout } = useLogout()

  return (
    <button className={`rounded-md px-1 hover:bg-slate-100/20 ${className}`} onClick={logout} title={t('Auth-logOut')}>
      <LogoutIcon className="" />
    </button>
  )
}

export default LogoutButton
